import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, CheckCircle } from 'lucide-react';

const LessonNavigation = ({ previousLesson, nextLesson, onComplete }) => {
  return (
    <div className="flex items-center justify-between py-6 border-t border-gray-200">
      <div>
        {previousLesson ? (
          <Link
            to={`/lessons/${previousLesson.lesson_id}`}
            className="btn-secondary inline-flex items-center"
          >
            <ChevronLeft size={20} className="mr-2" />
            Previous
          </Link>
        ) : (
          <div></div>
        )}
      </div>
      
      <button
        onClick={onComplete}
        className="btn bg-green-600 text-white hover:bg-green-700 inline-flex items-center"
      >
        <CheckCircle size={20} className="mr-2" />
        Mark as Complete
      </button>
      
      <div>
        {nextLesson ? (
          <Link
            to={`/lessons/${nextLesson.lesson_id}`}
            className="btn-primary inline-flex items-center"
          >
            Next
            <ChevronRight size={20} className="ml-2" />
          </Link>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default LessonNavigation;




